import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Info from "./Info"
import About from "./About"
import Activity from "./Activity"
import { useSelector } from "react-redux"
import ImageCropModal from "components/ImageCropModal"
import { toast } from "react-toastify"
import { updateUserProfile } from "../../../redux/actions/auth"
import { useDispatch } from "react-redux"

const Profile = () => {
  document.title = "Profile | PULA"
  const dispatch = useDispatch()
  const [profileFile, setProfileFile] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const [profileImage, setProfileImage] = useState(null)
  const [bannerImage, setBannerImage] = useState(null)
  const [aspectRatio, setAspectRatio] = useState(1)
  const [updating, setUpdating] = useState("profile") // profile || banner

  const user = useSelector(state => state.auth.user)
  const updateUserProfileScreen = useSelector(
    state => state.screens.updateUserProfile
  )

  const [activeTab, setActiveTab] = useState("1")

  useEffect(() => {
    if (user.user_profile_url) {
      convertUrlToBlob(
        "profileImage",
        user.profile_image,
        user.user_profile_url
      )
    }
    if (user.profile_banner_image_url) {
      convertUrlToBlob(
        "bannerImage",
        user.profile_banner_image,
        user.profile_banner_image_url
      )
    }
  }, [user])

  useEffect(() => {
    if (updateUserProfileScreen.success) {
      toast.success(updateUserProfileScreen.message)
    }
    if (updateUserProfileScreen.error) {
      toast.error(updateUserProfileScreen.error)
    }
  }, [updateUserProfileScreen])

  useEffect(() => {
    if (profileFile) {
      console.log("profileFile..", profileFile)

      setIsOpen(true)
    }
  }, [profileFile])

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  function onSelectFile(event) {
    console.log("files", event.target.files)

    const file = event.target.files[0]
    if (!file) return

    const supported = ["image/jpeg", "image/png", "image/jpg"]
    if (!supported.includes(file.type)) {
      alert("Please upload an image file (jpeg, jpg, png)")
      return
    }

    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader()
      reader.onload = e => {
        setProfileFile(e.target.result)
      }
      reader.readAsDataURL(event.target.files[0])
    }
  }

  function saveImage(blob, blobUrl) {
    console.log("blob..", blob)
    const file = new File([blob], "my_profile_pic.jpg", {
      type: blob.type,
      lastModified: Date.now(),
    })
    let formData = new FormData()
    formData.append("section", "profile_image")
    if (updating === "profile") {
      formData.append("user_photo", file)
      setProfileImage({
        name: file.name,
        file: file,
        url: blobUrl,
      })
    } else {
      formData.append("user_banner", file)
      setBannerImage({
        name: file.name,
        file: file,
        url: blobUrl,
      })
    }
    submitProfileChanges(formData)
    setProfileFile(null)
    setIsOpen(false)
  }

  async function convertUrlToBlob(fieldName, filename, url) {
    // Fetch the image data from the URL
    const response = await fetch(url)

    // Get the response data as a Blob
    const blob = await response.blob()

    // Determine the file type (MIME type) from the blob
    // Fallback to a default type if the response doesn't provide one
    const type = blob.type || "image/jpeg" //

    // Create a new File object using the Blob, filename, and type
    const file = new File([blob], filename, { type })

    console.log("file..", fieldName, file)

    if (fieldName === "profileImage") {
      setProfileImage({
        file,
        name: file.name,
        type: file.type,
        url: URL.createObjectURL(file),
      })
    } else {
      setBannerImage({
        file,
        name: file.name,
        type: file.type,
        url: URL.createObjectURL(file),
      })
    }
  }

  const submitProfileChanges = requestBody => {
    console.log("requestBody..", requestBody)
    dispatch(updateUserProfile(requestBody))
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <h4 className="h4 mt-3 mb-3 nom-title">Profile</h4>
        <div className="mb-3"></div>

        {/* Profile Header with Banner and Profile Image */}
        <div className="position-relative mb-4">
          {/* Banner Image */}
          <div className="position-relative">
            {bannerImage ? (
              <img
                src={bannerImage.url}
                alt="Profile Banner"
                className="w-100"
                style={{
                  height: "312px",
                  objectFit: "",
                  borderRadius: "10px",
                }}
              />
            ) : (
              <div
                className="w-100"
                style={{
                  height: "312px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #b3b3b3ff, #e0e0e0)",
                }}
              ></div>
            )}
            <label
              // htmlFor="profileUpload"
              className="position-absolute top-0 end-0 m-3 upload-btn"
              onClick={() => {
                document.getElementById("profileUpload").click()
                setAspectRatio(16 / 9)
                setUpdating("banner")
              }}
            >
              <i className="mdi mdi-camera"></i>
              Upload Photo
            </label>
          </div>

          {/* Profile Image and Info */}
          <div className="px-4">
            <div className="user-profile-img-wrapper">
              <div className="position-relative mb-3">
                {profileImage ? (
                  <img
                    src={profileImage.url}
                    alt="Profile"
                    className="rounded-circle border border-4 border-primary user-profile-image"
                  />
                ) : (
                  <>
                    <div className="rounded-circle border border-4 border-primary user-profile-image user-profile-without-img">
                      <i className="mdi mdi-account text-grey"></i>
                    </div>
                  </>
                )}
                <Button
                  color="light"
                  size="sm"
                  className="camera-icon"
                  onClick={() => {
                    document.getElementById("profileUpload").click()
                    setAspectRatio(1)
                    setUpdating("profile")
                  }}
                >
                  <i
                    className="mdi mdi-camera-enhance text-white"
                    style={{ fontSize: "16px" }}
                  ></i>
                </Button>

                <input
                  type="file"
                  id="profileUpload"
                  accept="image/*"
                  hidden
                  onChange={onSelectFile}
                />
              </div>

              <div className="ms-1 username-profile flex-grow-1">
                <h4>{`${user?.first_name} ${user?.last_name}`}</h4>

                <div className="d-flex align-items-center mb-1">
                  <i className="bx bx-check-circle text-success"></i>
                  <span className="text-muted">{user?.company_name}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Card>
          <Nav tabs className="nav nav-tabs nav-tabs-custom nav-justified">
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggleTab("1")}
              >
                <i className="bx bx-user-circle font-size-20"></i>
                <span className="font-size-18 d-sm-block">About</span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggleTab("2")}
              >
                <i className="bx bx-info-circle font-size-20"></i>
                <span className="font-size-18 d-sm-block">Business Info</span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab === "3" })}
                onClick={() => toggleTab("3")}
              >
                <i className="bx bx-time-five font-size-20"></i>
                <span className="font-size-18 d-sm-block">Activity</span>
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="p-4">
            <TabPane tabId="1">
              <Info submitProfileChanges={submitProfileChanges} />
            </TabPane>

            <TabPane tabId="2">
              <About submitProfileChanges={submitProfileChanges} />
            </TabPane>

            <TabPane tabId="3">
              <Activity />
            </TabPane>
          </TabContent>
        </Card>
      </div>
      <ImageCropModal
        isOpen={isOpen}
        imgSrc={profileFile}
        saveImage={saveImage}
        toggle={() => setIsOpen(false)}
        aspect={aspectRatio}
      />
    </div>
  )
}

export default Profile
